module.exports = __webpack_public_path__ + "img/logo-archie.cbb10cf5.svg";